import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PlaceholderPage } from '@/components/layout/PlaceholderPage';

export const Route = createFileRoute('/_app/rules')({
	component: RulesRoute,
});

function RulesRoute() {
	const { t } = useTranslation();
	return (
		<PlaceholderPage
			title={t('nav.rules')}
			description={t('placeholder.rules.description')}
			scope={t('placeholder.rules.scope')}
		/>
	);
}
